function CalendarNumber({ style }) {
  const { fill = '#9191A8', width = 24, height = 24 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M20.1 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H5.1a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 5.1 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 20.1 3ZM7.35 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3h2.25Zm12.75 15h-15V9h15v10.5Zm-9-8.25v6a.75.75 0 1 1-1.5 0v-4.787l-.415.208a.75.75 0 0 1-.671-1.342l1.5-.75a.75.75 0 0 1 1.086.671Zm5.546 2.855L14.85 16.5h1.5a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.6-1.2l2.698-3.597a.75.75 0 1 0-1.248-.828.75.75 0 1 1-1.298-.75 2.25 2.25 0 1 1 3.744 2.48Z"
      />
    </svg>
  );
}

export default CalendarNumber;
